var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoachLernen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_40648",
    "data-name": "Gruppe 40648",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40452",
    "data-name": "Gruppe 40452",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#e5f5f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40650",
    "data-name": "Gruppe 40650",
    transform: "translate(12.291 12.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48064",
    "data-name": "Pfad 48064",
    d: "M4.277,7.25A1.027,1.027,0,0,1,5.3,8.277V21.971a1.027,1.027,0,0,1-2.054,0V8.277A1.027,1.027,0,0,1,4.277,7.25Z",
    transform: "translate(0 1.478)",
    fill: "#1d9d87",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48065",
    "data-name": "Pfad 48065",
    d: "M19.685,23.306A14.053,14.053,0,0,0,7.912,29.684a1.027,1.027,0,1,1-1.721-1.122,16.107,16.107,0,0,1,26.986,0,1.027,1.027,0,0,1-1.721,1.122,14.053,14.053,0,0,0-11.772-6.378Z",
    transform: "translate(1.025 6.65)",
    fill: "#1d9d87",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48066",
    "data-name": "Pfad 48066",
    d: "M20.385,3.3a1.027,1.027,0,0,1,.65,0L37.467,8.78a1.027,1.027,0,0,1,0,1.949L21.034,16.206a1.028,1.028,0,0,1-.65,0L3.952,10.729a1.027,1.027,0,0,1,0-1.949ZM7.525,9.755,20.71,14.149,33.894,9.755,20.71,5.36Z",
    transform: "translate(0)",
    fill: "#1d9d87",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48067",
    "data-name": "Pfad 48067",
    d: "M12.487,9.795a1.027,1.027,0,0,1,.064,1.451,8.559,8.559,0,1,0,12.624,0,1.027,1.027,0,1,1,1.515-1.387,10.613,10.613,0,1,1-15.654,0,1.027,1.027,0,0,1,1.451-.064Z",
    transform: "translate(1.847 2.318)",
    fill: "#1d9d87",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachLernen);
export default __webpack_public_path__ + "static/media/Coach-Lernen.30bd10123f9f8df2fe64a7b931cfb095.svg";
export { ForwardRef as ReactComponent };